import React from 'react';
import { useLang } from '../i18n/translations';
import { CalendarPlus } from 'lucide-react';

const enc = encodeURIComponent;
const pad2 = (n) => String(n).padStart(2, '0');

const parts = (event) => {
  const time = event.time || '10:00';
  const [h, m] = time.split(':').map((x) => parseInt(x, 10) || 0);
  const endH = Math.min(h + 2, 23);
  const startDate = event.date;
  const endDate = event.endDate && event.endDate !== event.date ? event.endDate : event.date;
  return {
    start: `${startDate.replace(/-/g, '')}T${pad2(h)}${pad2(m)}00`,
    end: `${endDate.replace(/-/g, '')}T${pad2(endH)}${pad2(m)}00`,
    startIso: `${startDate}T${pad2(h)}:${pad2(m)}:00`,
    endIso: `${endDate}T${pad2(endH)}:${pad2(m)}:00`,
    loc: `${event.location}, ${event.city}`,
  };
};

export const AddToCalendar = ({ event }) => {
  const { t } = useLang();
  const p = parts(event);

  const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${enc(event.title)}&dates=${p.start}/${p.end}&details=${enc(event.description || '')}&location=${enc(p.loc)}`;
  const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${enc(event.title)}&startdt=${p.startIso}&enddt=${p.endIso}&body=${enc(event.description || '')}&location=${enc(p.loc)}`;

  const downloadIcs = () => {
    const ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//E-Turizam SBK//BS',
      'BEGIN:VEVENT', `UID:${event.id}@eturizam.ba`,
      `DTSTART:${p.start}`, `DTEND:${p.end}`,
      `SUMMARY:${event.title}`,
      `DESCRIPTION:${(event.description || '').replace(/\n/g, '\\n')}`,
      `LOCATION:${p.loc}`,
      'END:VEVENT', 'END:VCALENDAR',
    ].join('\r\n');
    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${event.title.replace(/[^\w\s-]/g, '').trim()}.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };

  const pill = 'inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs font-semibold text-white transition-transform duration-200 hover:scale-105';

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="add-to-calendar">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide mr-1">{t('addToCalendar')}:</span>
      <a href={googleUrl} target="_blank" rel="noreferrer" data-testid="cal-google"
        className={pill} style={{ backgroundColor: '#4285F4' }}>
        <i className="fa-brands fa-google text-[11px]" /> Google
      </a>
      <a href={outlookUrl} target="_blank" rel="noreferrer" data-testid="cal-outlook"
        className={pill} style={{ backgroundColor: '#0078D4' }}>
        <i className="fa-brands fa-microsoft text-[11px]" /> Outlook
      </a>
      <button onClick={downloadIcs} data-testid="cal-ics"
        className={pill} style={{ backgroundColor: '#475569' }}>
        <CalendarPlus className="h-3.5 w-3.5" /> .ics
      </button>
    </div>
  );
};
